import Http from '../../common/services/Http';
import { BulkImportDto, BulkImportTagsDto, BulkImportIdentificationTagsDto } from './models/BulkImportItemDto';
import { BulkImportPreviewDto, BulkImportResultDto } from './models/BulkImportResultDto';

class BulkImportService {
    // Vehicles
    public preview(model: BulkImportDto) {
        return Http.post<BulkImportPreviewDto>('bulkimport/preview', model);
    }

    public create(model: BulkImportDto) {
        return Http.post<BulkImportResultDto[]>('bulkimport', model);
    }

    public async exportCsv(companyId: string) {
        const blob = await Http.getWithConfig<Blob>(`bulkimport/export/${companyId}`, null, { responseType: 'blob' });
        this.downloadBlob(blob, 'vehicles_export.csv');
    }

    // Tags
    public previewTags(model: BulkImportTagsDto) {
        return Http.post<BulkImportPreviewDto>('bulkimport/tags/preview', model);
    }

    public syncTags(model: BulkImportTagsDto) {
        return Http.post<BulkImportResultDto[]>('bulkimport/tags', model);
    }

    public async exportTags(companyId: string) {
        const blob = await Http.getWithConfig<Blob>(`bulkimport/tags/export/${companyId}`, null, { responseType: 'blob' });
        this.downloadBlob(blob, 'tags_export.csv');
    }

    // Identification Tags
    public previewIdentificationTags(model: BulkImportIdentificationTagsDto) {
        return Http.post<BulkImportPreviewDto>('bulkimport/identificationtags/preview', model);
    }

    public syncIdentificationTags(model: BulkImportIdentificationTagsDto) {
        return Http.post<BulkImportResultDto[]>('bulkimport/identificationtags', model);
    }

    public async exportIdentificationTags(companyId: string) {
        const blob = await Http.getWithConfig<Blob>(`bulkimport/identificationtags/export/${companyId}`, null, { responseType: 'blob' });
        this.downloadBlob(blob, 'identification_tags_export.csv');
    }

    private downloadBlob(blob: Blob, filename: string) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
    }
}

export default new BulkImportService();
